import toast from 'react-hot-toast';

import { Sentry } from 'shared/sentry';

/**
 * Handles a failed action: logs it, reports it, and optionally tells the user.
 *
 * Catching an error stops it from reaching Sentry as an unhandled rejection, so report
 * it explicitly here — `beforeSend` in `shared/sentry.ts` still filters out the
 * transient/expected cases. Pass `userMessage` (e.g. `t('errors.error')`) whenever the
 * failure means the user's action silently did nothing.
 */
export const errorHandler = (error: any, userMessage?: string) => {
  console.error('Error: ', error);
  Sentry.captureException(error);
  if (process.env.REACT_APP_ENV === 'development') {
    toast.error(error?.message);
  } else if (userMessage) {
    toast.error(userMessage);
  }
};
